import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../SrpRightBlock/SrpRightBlock.styles';

import SortBy from '../SortBy/SortBy';
import SrpCardMainBlock from '../SrpCardMainBlock/SrpCardMainBlock';
import SearchResult from '../SearchResult/SearchResult';
import { sortBySelector, journeyTypeSelector, srpPrivateBusesSelector, srpRTCBusesSelector, srpRTCViewSelector, dataLoadingSelector, srpFiltersSelector, srpFilterCardsSelector } from './../../../../containers/SRP/redux/selectors';
import { updateSortBy, updateSelectedBus } from './../../../../containers/SRP/redux/actions';
import { sortBusData, fetchSrpDataThunk, checkSlPosition } from './../../../../containers/SRP/redux/thunks';
import { getFilterRegEx, isFilterEmpty, getInitSelectedFilters } from './../../../../containers/SRP/Utils';
import { fetchSeatLayoutData } from './../../../../containers/SeatLayout/redux/thunks'
import { updateSelectedBusData } from './../../../../containers/SeatLayout/redux/actions';
import { commonSelector } from './../../../../containers/Common/redux/selectors';
import dateformat from 'dateformat';
import SrpCardLoader from '../SrpLoader/SrpCardLoader/SrpCardLoader';
import NoResultsCard from '../NoResults/NoResults';
import { SRP } from './../../../../config/messages';
import { pushga } from 'ga-utils'
import { SrpGAEvents, SeatLayoutEvents } from './../../../../config/ga-config';
import getDateObj from './../../../../utils/GetDateObj'
import { replaceSRPUrlState } from './../../../../containers/Common/Utils';
import { useHistory } from 'react-router-dom';
import AdBanner from './../../../../components/AdBanner/AdBanner';
import { pushOmniEvents } from '../../../../utils/PushEvents/Omniture/utils'
import TopFilterCards from '../TopFilterCards/TopFilterCards'
import { getFilteredOperators } from '../SrpLeftBlock/SrpLeftBlock';
import { allFiltersApplied } from '../../../../utils/ctaHelper';
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils';
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents';
const SrpRightBlock = (props) => {
  const history = useHistory();
  const { sortBy } = useSelector(sortBySelector);
  const commonData = useSelector(commonSelector);
  const srpDataLoading = useSelector(dataLoadingSelector);
  const [addedSl, setAddedSl] = useState(true)
  const { src, dest, src_vid, dest_vid, doj, dojObj, src_name, dest_name } = commonData;
  const dispatch = useDispatch();
  const { selectedFilters, setSelectedFilters } = props;
  const { filters } = useSelector(srpFiltersSelector);
  const { operators } = filters;
  const filter_cards = useSelector(srpFilterCardsSelector)
  const journeyType = useSelector(journeyTypeSelector);
  const { privateAvailableBuses, privateSoldOutBuses } = useSelector(srpPrivateBusesSelector);
  const { rtcBuses } = useSelector(srpRTCBusesSelector);
  const { rtcView } = useSelector(srpRTCViewSelector);
  const busesAvailable = privateAvailableBuses[journeyType];
  const [is_bo_ads, setIs_bo_ads] = useState(false)
  useEffect(()=>{
    if(busesAvailable && addedSl){
      dispatch(checkSlPosition('onLoad'))
      setAddedSl(!addedSl)
    }
  },[busesAvailable, addedSl])

  const soldOutBuses = privateSoldOutBuses[journeyType];
  let filtersEmpty = true;
  let pattern = new RegExp(/.*/);
  const onFilterCardClick = (filter_name, filterType, isBoAd) =>{  
    setIs_bo_ads(isBoAd)
    let tempFilters =  Object.assign({}, getInitSelectedFilters(true));
    pushCtaOmniEvents('filterCard_primo/filterCard_godeal/filterCard_BO_ads', CTA_TYPE.BUTTON, 'filter_cards', 'SRP');
    if(filterType === 'popular'){
    tempFilters?.popular?.push(filter_name)
    setSelectedFilters(tempFilters)
    }
    else if(filterType === ''){
      tempFilters = Object.assign({}, getInitSelectedFilters(true));
      setSelectedFilters(tempFilters)
    }
    else{
      let selectedOpFilter = getSelectedOpFilter(operators['onw'], filter_name)
      tempFilters.operator = selectedOpFilter || {}
      setSelectedFilters(tempFilters)
      const eventDetails = {
        filter : {
          appliedFiltersList : allFiltersApplied(tempFilters)
        }
      }
      pushOmniEvents({eventName:'filterCardClick', details:eventDetails})
    }
   
    return

    // filterRemoved:selectedValue,
  }
  const getSelectedOpFilter = (data, filterName) => {
    let result = {}
      for(let item of data){
        if(item.name === filterName){
          result[item.id] =   item.name
          return result
        }
      }
  }
  if (!isFilterEmpty(selectedFilters)) {
    filtersEmpty = false;
    pattern = getFilterRegEx(selectedFilters, filters.popularFilters);
  }
  const { viewData: availableBusesViewData } = getBusViewData(busesAvailable, pattern); //TODO:- move this to selector

  const { viewData: soldOutBusesViewData } = getBusViewData(soldOutBuses, pattern); //TODO:- move this to selector

  const { rtcBusesViewData, rtcBusCount } = getRTCViewData(journeyType, rtcBuses, rtcView, pattern); //TODO:- move this to selector
 
  const selectedSeatLayoutData = {};
  const busCount = rtcBusCount + availableBusesViewData.length + soldOutBusesViewData.length;
  const busesAvailableCount = busesAvailable ? busesAvailable.length : 0;
  const soldOutBusCount = soldOutBuses ? soldOutBuses.length : 0;

  const onSortClick = (evt) => {
    const val = evt.target.dataset.val;
    if (val) {
      dispatch(updateSortBy(val));
      dispatch(sortBusData(val));
      dispatch(checkSlPosition(val === 'best' ? 'best' : 'sorting'))
      pushga({
        event: SrpGAEvents.actions.bus_srp_sort.val,
        eventCategory: SrpGAEvents.category,
        eventAction: SrpGAEvents.actions.bus_srp_sort.val,
        eventLabel: SrpGAEvents.actions.bus_srp_sort.labels[val] || ''
      });
      const strSplit = val.split('_');
      const sortKey = strSplit && strSplit[0];
      const sortValue = strSplit && strSplit[1];
      pushOmniEvents({eventName:'sortApplied', details:{sort:{sortOption:`${sortValue?sortValue:''}:${sortKey?sortKey:''}`}}})
    }
  }

  const totalRTCCount = function () {
    let count = 0;
    if (rtcBuses && Object.keys(rtcBuses).length) {
      for (const i in rtcBuses) {
        if (rtcBuses.hasOwnProperty(i) && rtcBuses[i][journeyType]) {
          count += rtcBuses[i][journeyType].busCount;
        }
      }
    }
    return count;
  }()

  let rawBusCount = busesAvailableCount + soldOutBusCount + totalRTCCount;
  let showPreviousLink = function () {
    let show = false;
    const currentDate = getDateObj();

    if (dojObj && dateformat(dojObj, 'yyyymmdd') !== dateformat(currentDate, 'yyyymmdd') && dojObj.getTime() > currentDate.getTime()) {
      show = true;
    }
    return show;
  }()


  return (
    <S.SrpRightBlockLayoutDiv id="srpCardLayoutinner">
     {filter_cards && filter_cards.length > 0 && <TopFilterCards filter_cards={filter_cards} onFilterCardClick={onFilterCardClick} />}
      {srpDataLoading ? null :
        <S.SortByContainer>
          {/* <SearchResult
            busCount={busCount}
            showPreviousLink={showPreviousLink}
            onPreviousDayClick={() => {
              const currentDate = dojObj;
              currentDate.setDate(dojObj.getDate() - 1);

              dispatch(fetchSrpDataThunk({

                src,
                dest,
                src_id: src_vid,
                dest_id: dest_vid,
                doj: dateformat(currentDate, "yyyymmdd"),
                src_name,
                dest_name
              }));
              replaceSRPUrlState({
                history,
                search: window.location.search,
                keyName: 'bid',
                inputValues: {
                  src_name,
                  dest_name,
                  src_vid,
                  dest_vid,
                  selectedDate: currentDate

                }

              })

              pushga({
                event: SrpGAEvents.actions.bus_previousday,
                eventCategory: SrpGAEvents.category,
                eventAction: SrpGAEvents.actions.bus_previousday,
              });


            }}
            onNextDayClick={() => {
              const currentDate = dojObj;

              currentDate.setDate(dojObj.getDate() + 1);
              dispatch(fetchSrpDataThunk({
                src,
                dest,
                src_id: src_vid,
                dest_id: dest_vid,
                doj: dateformat(currentDate, "yyyymmdd"),
                src_name,
                dest_name
              }));
              replaceSRPUrlState({
                history,
                search: window.location.search,
                keyName: 'bid',
                inputValues: {
                  src_name,
                  dest_name,
                  src_vid,
                  dest_vid,
                  selectedDate: currentDate
                }
              })
              pushga({
                event: SrpGAEvents.actions.bus_nextday,
                eventCategory: SrpGAEvents.category,
                eventAction: SrpGAEvents.actions.bus_nextday,
              });

            }}
          /> */}

          <SortBy
            busCount={busCount}
            type={sortBy}
            onClick={onSortClick}
          />
        </S.SortByContainer>
      }

      {!busCount && !srpDataLoading && filtersEmpty ? <NoResultsCard busCount={rawBusCount}
        message={SRP.NOBUS_FOUND}
      /> : null}

      {!busCount && !srpDataLoading && !filtersEmpty ? <NoResultsCard busCount={rawBusCount} cb={() => {
        setSelectedFilters(Object.assign({}, getInitSelectedFilters(true)));
      }}
        message={SRP.NOBUS_FOUND_FILTER}
        subText={`Reset filter(s) to see all ${rawBusCount} buses.`}
      />
        : null}
      {srpDataLoading ? <>
        <SrpCardLoader />
        <SrpCardLoader />
        <SrpCardLoader />
        <SrpCardLoader />
        <SrpCardLoader />
      </> : <SrpCardMainBlock
        availableBusesViewData={availableBusesViewData}
        rtcBusesViewData={rtcBusesViewData}
        soldOutBusesViewData={soldOutBusesViewData}
        rtcView={rtcView}
        selectedSeatLayoutData={selectedSeatLayoutData}
        openSeatLayout={params => {
          const { bid, is_nitro = false, nitro_offer = {} } = params;
          if (is_nitro && nitro_offer) {
            pushga({
              event: SeatLayoutEvents.actions.lastMinutebBooking.val,
              eventCategory: SeatLayoutEvents.category,
              eventAction: SeatLayoutEvents.actions.lastMinutebBooking.val,
              eventLabel: SeatLayoutEvents.actions.lastMinutebBooking.label,
            });
          }

          dispatch(updateSelectedBus(bid));
          //TODO:- if bus Data have only bp and dp then add the case here only to fetch seat Layout
          if (params.chooseBpDpFirst || params.cat_card) {
            dispatch(updateSelectedBusData({ bid: bid, data: {}, isLoading: false, error: false }));
          } else {
            dispatch(fetchSeatLayoutData({ busInfo: params }));
          }
        }}
        is_bo_ads={is_bo_ads}
      />
      }
      <div style={{ display: !srpDataLoading && !busCount && !rawBusCount ? '' : 'none', width: '100%', paddingLeft: "5rem" }}>
        <AdBanner cid="QlVTI1NSUCNDRU5URVI=" />
      </div>
    </S.SrpRightBlockLayoutDiv>
  );
};

export default SrpRightBlock;

const getRTCViewData = (journeyType, rtcBuses, rtcView, pattern) => {
  let rtcBusCount = 0;
  let rtcBusesViewData = [];
  for (const rtcId in rtcBuses) {
    if (rtcBuses.hasOwnProperty(rtcId)) {
      let rtcParams: {
        busCount: number;
        earliest_departure: string;
        fastest_duration: string;
        slowest_duration: string;
        seatCount: number;
        cheapest_price: number;
      } = {
        busCount: 0,
        earliest_departure: '',
        fastest_duration: '',
        slowest_duration: '',
        seatCount: 0,
        cheapest_price: 0,
      };
      const operator = rtcBuses[rtcId];
      let { viewData: availableBusesViewData, rtcParams: rtcCardData } = getBusViewData(
        operator[journeyType].availableBuses,
        pattern,
        rtcParams,
      );
      const { viewData: soldOutBusesViewData } = getBusViewData(
        operator[journeyType].soldOutBuses,
        pattern,
        rtcParams,
      );
      rtcBusesViewData.push({
        image_url: operator.img_url,
        name: operator.name,
        fullName: operator.f_name,
        startTime: rtcCardData.earliest_departure,
        minDuration: rtcCardData.fastest_duration,
        maxDuration: rtcCardData.slowest_duration,
        startPrice: rtcCardData.cheapest_price,
        availableBusCount: rtcCardData.busCount,
        seatsAvailable: rtcCardData.seatCount,
        active: operator.opid === rtcView,
        availableBuses: operator[journeyType].availableBuses,
        soldOutBuses: operator[journeyType].soldOutBuses,
        availableBusesViewData: availableBusesViewData,
        soldOutBusesViewData: soldOutBusesViewData,
        opid: operator.opid,
        msg: operator?.msg
      });
      rtcBusCount += availableBusesViewData.length + soldOutBusesViewData.length;
    }
  }

  return { rtcBusesViewData, rtcBusCount };
}

const getBusViewData = (busData, pattern, rtcParams = {}) => {
  let viewData = [];
  if (busData) {
    busData.map((bus, ind) => {
      const { rating, rc, ps, bt, cr, du, dt, dd, at, ad, bp, dp, rd } = bus.fl[0];

      const { pp, tf } = bus.fd;
      const isRedDeal = bus.reddeal && bus.reddeal.offerDesc ? true : false;
      let seatsAvailable = rd && rd.length && rd[0].SeatsAvailable ? rd[0].SeatsAvailable : 0
      if (pattern.test(bus.filterHash)) {
        if (rtcParams && Object.keys(rtcParams).length) {
          rtcParams = rtcCardInfo(rtcParams, du, seatsAvailable, bus.fd.tf, dt);
        }
        if(bus.adInventoryData !== null && pattern && ind > 3){
          const temp = busData[3];
          busData[3] = bus;
          busData[ind] = temp;
          if(!busData[3].showAsAd){
            busData[3].showAsAd = true
          }
         }
        viewData.push({
          scheduleTxt: bus.zct_msg,
          go_safe: bus.go_safe,
          soc_dis: bus.soc_dis,
          ptag: bus?.ptag ? bus.ptag : {},
          is_nitro: bus?.is_nitro ? bus.is_nitro : false,
          nitro_offer: bus?.nitro_offer ? bus.nitro_offer : {},
          fast_persuasion: bus?.fast_persuasion ? bus.fast_persuasion : {},
          soc_dis_msg: bus.soc_dis_msg,
          alertTxt: ps.t,
          operatorName: cr,
          busType: bt,
          rating: parseFloat(rating),
          ratingCount: parseInt(rc, 10),
          departureTime: dt,
          departurePoint: (function () {
            let point = '';
            const bp = bus.card_BPDP_Info.bp;
            for (const i in bp) {
              const BPTime = bp[i].BPTime;
              if (BPTime) {
                const bpTime = BPTime.split('T')[1];
                const comparabaleBPTime = bpTime.substr(0, bpTime.lastIndexOf(':'));
                if (comparabaleBPTime === dt) {
                  point = bp[i].BPN;
                  break;
                }
              }
            }
            return point;
          })(),
          adInventoryData: bus?.adInventoryData || null,
          duration: du,
          restStops: bus.rs && bus.rs.length && Object.keys(bus.rs[0]).length ? bus.rs.length : 0,
          arrivalDate: dateformat(ad, 'dS mmm'),
          arrivaleTime: at,
          destinationPoint: (function () {
            let point = '';
            const dp = bus.card_BPDP_Info.dp;

            for (const i in dp) {
              const DPTime = dp[i].DPTime;
              if (DPTime) {
                const dpTime = DPTime.split('T')[1];
                const comparabaleDPTime = dpTime.substr(0, dpTime.lastIndexOf(':'));
                if (comparabaleDPTime === at) {
                  point = dp[i].DPN;
                  break;
                }
              }
            }
            return point;
          })(),
          isRedDeal: isRedDeal,
          personalisedPrice: pp,
          totalFare: tf,
          reddeal: bus?.reddeal ? bus.reddeal : {},
          seatsAvailable,
          fh: bus.fh,
          bid: bus.bid,
          src_id: bus.src_id,
          dest_id: bus.dest_id,
          searchtype: bus.rt,
          origin: bus.fl[0].fr,
          destination: bus.fl[0].to,
          journey_date: bus.fl[0].dd,
          src_vid: bus.fl[0].src_vid,
          dest_vid: bus.fl[0].dest_vid,
          fl: bus.fl,
          bpid: '',
          dpid: '',
          op: bus.op,
          gps: bus.fl[0].gps,
          ot: bus.fl[0].ot,
          aws: bus.fl[0].aws,
          amenities: bus.amenities,
          card_ps: bus.card_ps,
          socialDistanceIcon: function () {
            if (bus.sl && bus.sl.length && bus.sl[0].title.toLowerCase().indexOf("social") !== -1 && bus.sl[0].title.toLowerCase().indexOf("distanc") !== -1) {
              return bus.sl[0];
            }
            return {}
          }(),
          socialDistance: bus.socialDistance,
          rs: (function () {
            const restStops = bus.rs;
            return restStops.map(rs => {
              const arr = rs.arrivalTime && rs.arrivalTime.length ? rs.arrivalTime.split(':') : [];
              rs.viewTime =
                arr && arr.length ? `${arr[0]}:${arr[1]} ${arr[0] > 12 ? ' PM' : ' AM'}` : '';
              return rs;
            });
          })(),
          biurl: bus.biurl,
          chooseBpDpFirst: bus.chooseBpDpFirst,
          cat_card: bus.cat_card,
          fd: bus.fd,
          cat_list: function () {

            let obj = {}
            if (bus.cat_list && bus.cat_list.length) {
              for (const i in bus.cat_list) {
                obj[bus.cat_list[i].cat_type] = bus.cat_list[i];
              }
            }
            return obj;
          }(),
          bps: (function () {
            const boardingPoints = Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp];
            return boardingPoints.map(boardingPoint => {
              boardingPoint = {
                ...boardingPoint,
                add: boardingPoint.BPAddress,
                contact: boardingPoint.BPContactNumber,
                lm: boardingPoint.BPLandmark,
                loc: boardingPoint.BPLocation,
                name: `${boardingPoint.BPId}-${boardingPoint.BPN}`,
                time: boardingPoint.BPTime,
                id: boardingPoint.BPId,
                n: boardingPoint.BPN,
                c: boardingPoint.BPCoordinates,
              };
              return boardingPoint;
            });
          })(),
          dps: (function () {
            const droppingPoints = Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp];
            return droppingPoints.map(droppingPoint => {
              droppingPoint = {
                ...droppingPoint,
                add: droppingPoint.DPAddress,
                contact: droppingPoint.DPContactNumber,
                lm: droppingPoint.DPLandmark,
                loc: droppingPoint.DPLocation,
                name: `${droppingPoint.DPId}-${droppingPoint.DPN}`,
                time: droppingPoint.DPTime,
                id: droppingPoint.DPId,
                n: droppingPoint.DPN,
                c: droppingPoint.DPCoordinates,
              };
              return droppingPoint;
            });
          })(),
         
        });
      } else {
      }
    });
  }
  return { viewData, rtcParams };
}

const rtcCardInfo = (rtcParams, duration, seatsAvailable, price, departureTime) => {
  let {
    earliest_departure,
    fastest_duration,
    slowest_duration,
    seatCount,
    cheapest_price,
    busCount,
  } = rtcParams;

  if (!earliest_departure) {
    fastest_duration = duration;
    slowest_duration = duration;
    cheapest_price = price;
    earliest_departure = departureTime;
  } else {
    const rtcFastestDuration = fastest_duration ? fastest_duration.split(' ') : [];

    const rtcSlowestDuration = slowest_duration ? slowest_duration.split(' ') : [];

    const busDurationTime = duration ? duration.split(' ') : [];
    const rtcDepartureTime = earliest_departure ? earliest_departure.split(':') : [];
    const busDepartureTime = departureTime ? departureTime.split(':') : [];
    if (rtcFastestDuration && rtcFastestDuration.length && rtcFastestDuration.length > 1 && busDurationTime && busDurationTime.length > 1) {
      const rtcMin = parseInt(rtcFastestDuration[1].replace(/m/g, ''), 10);
      const rtcDuration = parseFloat(`${rtcFastestDuration[0].replace(/h/g, '')}${rtcMin / 60}`);
      const busMin = parseInt(busDurationTime[1].replace(/m/g, ''), 10);
      const busDuration = parseFloat(`${busDurationTime[0].replace(/h/g, '')}${busMin / 60}`);
      if (busDuration < rtcDuration) {
        fastest_duration = duration;
      }
    }
    if (rtcSlowestDuration && rtcSlowestDuration.length && rtcSlowestDuration.length > 1 && busDurationTime && busDurationTime.length > 1) {
      const rtcMin = parseInt(rtcSlowestDuration[1].replace(/m/g, ''), 10);
      const rtcDuration = parseFloat(`${rtcSlowestDuration[0].replace(/h/g, '')}${rtcMin / 60}`);
      const busMin = parseInt(busDurationTime[1].replace(/m/g, ''), 10);
      const busDuration = parseFloat(`${busDurationTime[0].replace(/h/g, '')}${busMin / 60}`);
      if (busDuration > rtcDuration) {
        slowest_duration = duration;
      }
    }
    if (
      rtcDepartureTime &&
      busDepartureTime &&
      parseInt(rtcDepartureTime.join('')) > parseInt(busDepartureTime.join(''))
    ) {
      earliest_departure = departureTime;
    }
  }

  if (cheapest_price > price) {
    cheapest_price = price;
  }

  seatCount += seatsAvailable;
  busCount += 1;
  return {
    earliest_departure,
    fastest_duration,
    slowest_duration,
    seatCount,
    cheapest_price,
    busCount,
  };
}
